export class UnderstandConstants {
  public static defaultSettingsCategories(): any[] {
    return ['trends'] ;
  }

  public static get errorText(): string {
    return 'There was an error loading the Understand tiles. Please try again later.';
  }

  public static get RecoveryTypeFilterTitle(): string {
    return 'Recovery Type';
  }

  public static get RecoveryTypeFilterRewardsRaw(): string {
    return 'REFUND_TYPE_REWARD';
  }

  public static get RecoveryTypeFilterRewardsDisplay(): string {
    return 'Reward(s)';
  }

  public static get CemRewardHoverText(): string {
    return 'This is a CEM Reward. There is no associated redemption data.';
  }

  public static get ExcludeCemRewardText(): string {
    return 'Exclude CEM Rewards';
  }

  public static get ExcludeCemRewardId(): string {
    return 'excludeCemRewards';
  }

  public static get ExcludeCemRewardCol(): string {
    return 'cemReward';
  }

  public static get ExcludeSingleRecipientCampaignsText(): string {
    return 'Exclude Single-Recipient Campaigns';
  }

  public static get ExcludeSingleRecipientCampaignsId(): string {
    return 'excludeSingleRecipientCampaigns';
  }

  public static get RecoveryTypeFilterPointsRaw(): string {
    return 'REFUND_TYPE_POINTS';
  }

  public static get RecoveryTypeFilterPointsDisplay(): string {
    return 'Points';
  }

  public static get RecoveryTypeFilterItemRemadeRaw(): string {
    return 'REFUND_TYPE_REALTIME_RECOVERY';
  }

  public static get RecoveryTypeFilterItemRemadeDisplay(): string {
    return 'Item Remade';
  }

  public static get rewardCampaignsFooterNote(): string {
    return 'Disabled Customers are no longer in your Restaurant Spotlight.';
  }

  public static get newTileIds(): string[] {
    return ['spotTheCow'];
  }

  public static get newTileTooltip(): string {
    return 'Number of Spot the Cows rewards redeemed at your restaurant. You can target these customers by using the ' +
      '"Has Redeemed Spot the Cows Reward" filter on the Meet page under "Customer Actions".';
  }
}
